import type { Locale } from "@/shared/utils/types";

export const CALENDAR_LOCALE: Record<
  Locale,
  {
    months: string[];
    monthsShort: string[];
    weekdays: string[];
    done: string;
    hour: string;
    minute: string;
    selectTime: string;
    quarters: string[];
    yearSuffix: string;
    freeRange: string;
    back: string;
  }
> = {
  ru: {
    months: [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ],
    monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    weekdays: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
    done: "Готово",
    hour: "час",
    minute: "мин",
    selectTime: "Выберите время",
    quarters: ["1 квартал", "2 квартал", "3 квартал", "4 квартал"],
    yearSuffix: "год",
    freeRange: "Свободный выбор",
    back: "Назад",
  },

  kk: {
    months: [
      "Қаңтар",
      "Ақпан",
      "Наурыз",
      "Сәуір",
      "Мамыр",
      "Маусым",
      "Шілде",
      "Тамыз",
      "Қыркүйек",
      "Қазан",
      "Қараша",
      "Желтоқсан",
    ],
    monthsShort: ["Қаң", "Ақп", "Нау", "Сәу", "Мам", "Мау", "Шіл", "Там", "Қыр", "Қаз", "Қар", "Жел"],
    weekdays: ["Дс", "Сс", "Ср", "Бс", "Жм", "Сб", "Жс"],
    done: "Дайын",
    hour: "сағат",
    minute: "мин",
    selectTime: "Уақытты таңдаңыз",
    quarters: ["1 тоқсан", "2 тоқсан", "3 тоқсан", "4 тоқсан"],
    yearSuffix: "жыл",
    freeRange: "Еркін таңдау",
    back: "Артқа",
  },

  en: {
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    done: "Done",
    hour: "hour",
    minute: "min",
    selectTime: "Select time",
    quarters: ["Q1", "Q2", "Q3", "Q4"],
    yearSuffix: "",
    freeRange: "Custom range",
    back: "Back",
  },
};
